var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.zusatzfunktionen),function(zf,index){return _c('div',{key:zf.f},[_c('Zusatzfunktion',{attrs:{"header":index == 0,"kunde":_vm.kunde,"field":zf.f,"titleKey":zf.t,"textKey":zf.x}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }